import {TOKEN_STATUSES} from '../../../components/nominex/Tokens/tokenUtils';
import {Alert, Badge, Card, CardBody, Col, Row, Spinner} from 'reactstrap';
import {useNQuery} from '../../../services/decorators/apolloGraphQL';
import React, {useEffect, useState} from 'react';
import ReactJson from 'react-json-view';
import {gql} from '@apollo/client';

const TokenView = (props = {}) => {
    //Consts&states
    const {id = null} = props;
    const [error, setError] = useState(null);
    const [tokenData, setTokenData] = useState(null);
    const [loading, setLoading] = useState(true);

    //queries&mutations
    const GET_ENTITY = {
        query: gql`
            query{
                responseQuery: tokenAutorizacion(id:"${id}"){
                    id
                    estatus
                    payload
                    accion{
                        titulo
                    }
                    solicitante{
                        nombres
                        apellidos
                    }
                    aprobador{
                        nombres
                        apellidos
                    }
                }
            }
        `
    };

    //handleFunctions
    const {
        runQuery: executeQueryEntity,
        data: dataEntity,
        loading: loadingEntity,
        error: errorEntity,
    } = useNQuery(GET_ENTITY);

    //effects
    useEffect(() => {
        if (id) executeQueryEntity().then();
    }, [id]);

    useEffect(() => {
        if (!loadingEntity && !errorEntity && dataEntity) {
            setLoading(false);
            setError(false);
            setTokenData(arrangeNotificationData(dataEntity.responseQuery));
        } else if (errorEntity) {
            setLoading(false);
            setError(true);
        }
    }, [dataEntity, loadingEntity, errorEntity]);

    //arrangeData
    const arrangeNotificationData = (dataItem) => {
        let response = null;
        if (dataItem) {
            let estatusData;
            const {accion, solicitante, aprobador} = dataItem;
            const accionTitulo = accion ? `${accion.titulo}` : ``;
            const usuarioAprobador = aprobador ? `${aprobador.nombres} ${aprobador.apellidos}` : ``;
            const usuarioSolicitante = solicitante ? `${solicitante.nombres} ${solicitante.apellidos}` : ``;
            Object.keys(TOKEN_STATUSES).forEach((subjectKey) => {
                if (TOKEN_STATUSES[subjectKey].slug === dataItem?.estatus) {
                    estatusData = TOKEN_STATUSES[subjectKey];
                }
            });
            response = {...dataItem, estatusData, accionTitulo, usuarioAprobador, usuarioSolicitante};
        }
        return response;
    }

    //Response
    return (
        <React.Fragment>
            <Row>
                <Col sm='12'>
                    {(loading) ? (
                        <Card>
                            <CardBody className='text-center'>
                                <Spinner color='primary' size='lg'/>
                            </CardBody>
                        </Card>
                    ) : error ? (
                        <Card>
                            <CardBody>
                                <Alert color='danger'>
                                    <div className='alert-heading'>Error</div>
                                    Lo sentimos, hubo un problema al intentar obtener la información de esta sección,
                                    favor de intentarlo más tarde o ponerse en contacto con el proveedor del sistema.
                                </Alert>
                            </CardBody>
                        </Card>
                    ) : (
                        <>
                            <div className='full-width d-flex justify-content-between p-1'>
                                <h5>Acción</h5>
                                <span>{tokenData.accionTitulo}</span>
                            </div>
                            <TokenEstatus
                                label={tokenData.estatusData.label}
                                color={tokenData.estatusData.color}
                            />
                            <div className='full-width d-flex justify-content-between p-1'>
                                <h5>Solicitante</h5>
                                <span>{tokenData.usuarioSolicitante}</span>
                            </div>
                            <div className='full-width d-flex justify-content-between p-1'>
                                <h5>Dictaminador</h5>
                                <span>{tokenData.usuarioAprobador}</span>
                            </div>
                            <Card>
                                <CardBody className='full-width'>
                                    <div className='full-width d-flex justify-content-center py-1'>
                                        <ReactJson
                                            name='payload'
                                            collapsed={false}
                                            quotesOnKeys={false}
                                            style={{zIndex: 100}}
                                            enableClipboard={false}
                                            src={tokenData.payload}
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        </>
                    )}
                </Col>
            </Row>
        </React.Fragment>
    );
};

const TokenEstatus = (props) => {
    const {label, color} = props;
    return (
        <div className='full-width d-flex justify-content-between p-1'>
            <h5>Estatus</h5>
            {label && (
                <div className='d-flex align-items-center'>
                    <Badge pill color={color}>&nbsp;&nbsp;</Badge>
                    <span className='my-auto' style={{paddingLeft: '4px'}}>{label}</span>
                </div>
            )}
        </div>
    )
}

export default TokenView;